import { render, staticRenderFns } from "./Gruppe.vue?vue&type=template&id=021ec56a&scoped=true&"
import script from "./Gruppe.vue?vue&type=script&lang=js&"
export * from "./Gruppe.vue?vue&type=script&lang=js&"
import style0 from "./Gruppe.vue?vue&type=style&index=0&id=021ec56a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021ec56a",
  null
  
)

export default component.exports